<template>
  <div>
    <!-- @click="to(item)" -->
    <button
      @click="$emit('onPress')"
      class="focus:outline-none md:w-full w-full md:px-0"
    >
      <div class="bg_color_btn px-4 py-2">
        {{ label }}
      </div>
    </button>
  </div>
</template>
<script>
export default {
  props: ["label", "src"],
};
</script>

<style scoped>
.bg_color_btn:hover {
  background: rgb(152, 4, 4);
  color: #fff;
}
.bg_color_btn:active{
  background:rgb(116, 3, 3);
}
</style>